import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import HelpIcon from 'material-ui/svg-icons/action/help';
import { IconButton } from 'material-ui';
import humanize from 'humanize-string';
import _ from 'lodash';
import { TRIGGER_SCHEMAS } from 'dash-front/triggerConstants';
import { presence, numeric, parseNumber, normalizeArray, formatArray } from 'dash-front/helpers/validation';
import { DotDivider } from '../helpers';

const PayloadForm = ({ triggerType }) => {
    const triggerProps = _.get(TRIGGER_SCHEMAS[triggerType], 'properties', {});
    return (
        <div style={{ display: 'flex' }}>
            {Object.keys(triggerProps).filter(e => e !== 'debug').map((name, index) => {
                const curProp = triggerProps[name];
                const validateFunctions = [];
                let isNumeric = curProp.type === 'integer';
                const isArray = curProp.type === 'array';
                let additionalProps = {};
                if (curProp.required) {
                    validateFunctions.push(presence);
                }
                if (isNumeric) {
                    validateFunctions.push(numeric);
                }
                if (isArray) {
                    isNumeric = curProp.items.type === 'integer';
                    additionalProps = {
                        ...additionalProps,
                        normalize: normalizeArray(isNumeric),
                        format: formatArray
                    };
                }
                return (
                    <span key={name} style={{ display: 'flex', alignItems: 'baseline' }}>
                        {Boolean(index) && <DotDivider />}
                        <Field
                            type={isNumeric && !isArray ? 'number' : 'text'}
                            parse={isNumeric && !isArray ? parseNumber : undefined}
                            name={name}
                            component={TextField}
                            style={{ width: 120 }}
                            floatingLabelText={humanize(name)}
                            validate={validateFunctions}
                            {...additionalProps}
                        />
                        {isArray
                            && <IconButton tooltip={'Split by spaces'}><HelpIcon /></IconButton>}
                    </span>
                );
            })}
        </div>
    );
};

PayloadForm.propTypes = {
    triggerType: PropTypes.string
};

export default PayloadForm;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/PayloadForm.js
 **/